import { render, staticRenderFns } from "./UploadVideos.vue?vue&type=template&id=20745c23&scoped=true&"
import script from "./UploadVideos.vue?vue&type=script&lang=js&"
export * from "./UploadVideos.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideos.vue?vue&type=style&index=0&id=20745c23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20745c23",
  null
  
)

export default component.exports